import { useMutation } from "@tanstack/react-query";

import { useGroupReferences } from "@contexts/GroupReferences/GroupReferences.context";
import { apiEcmsHttp } from "@services/http";
import { QUERY_KEYS } from "@services/keys";

import type {
  PostBillConsolidationsFilter,
  PostBillConsolidationsFilterPayload,
} from "./apiEcms.types";

const postBillConsolidationsFilter = (
  payload: PostBillConsolidationsFilterPayload,
) =>
  apiEcmsHttp.post<PostBillConsolidationsFilter>(
    "/bill-consolidations/filter",
    payload.inputsPayload,
    {
      params: {
        page: payload.paginationPayload.page,
        size: payload.paginationPayload.size,
      },
    },
  );

export const usePostBillConsolidationsFilter = () => {
  const { currentGroup } = useGroupReferences();

  return useMutation({
    mutationFn: postBillConsolidationsFilter,
    retry: false,
    mutationKey: [QUERY_KEYS.BILL_CONSOLIDATIONS_FILTER, currentGroup],
  });
};
